import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet';
import { canonicalUrl } from '../siteConfig';

const SERVICE_SECTIONS = [
  {
    title: 'Network Infrastructure',
    icon: 'fas fa-network-wired',
    learnMoreHref: '/services/network-infrastructure',
    items: [
      'Network infrastructure design & implementation for new construction and renovations',
      'Small business network upgrades',
      'Firewall configuration and network assessments',
      'VLAN design for segmented systems (office, guest, AV, security, IoT)',
      'Wireless access point placement and installation',
      'VPN configuration',
      'Network documentation (WAP placement, cabling schedules, network riser diagrams, logical network design)',
    ],
  },
  {
    title: 'Storage & Backup',
    icon: 'fas fa-database',
    learnMoreHref: '/services/storage-and-backup',
    items: [
      'NAS deployment and configuration',
      'On-premise and cloud storage setup',
      'Backup strategy & data redundancy',
      'Backup validation and recovery testing',
      'Disaster recovery planning',
      'File server & storage modernization',
    ],
  },
  {
    title: 'Cloud & Identity',
    icon: 'fas fa-cloud',
    items: [
      'Microsoft 365 setup & administration',
      'Google Workspace setup & administration',
      'Email migrations',
      'User and identity management',
      'Authentication and access controls',
    ],
  },
  {
    title: 'Domains, DNS & Integrations',
    icon: 'fas fa-globe',
    learnMoreHref: '/services/domains-dns-integrations',
    items: [
      'DNS troubleshooting',
      'Domain registration & management',
      'Website hosting & migrations',
      'SPF, DKIM, and DMARC configuration',
      'SSL certificate management',
      'SaaS integrations'
    ],
  },
];

function ServiceItem({ text }) {
  return (
    <li className="service-item">
      <img className="check" alt="" src="assets/images/check.svg" aria-hidden="true" />
      <span>{text}</span>
    </li>
  );
}

function ServiceSection({ title, icon, items, learnMoreHref }) {
  return (
    <article className="service-section-card">
      <header className="service-section-header">
        <span className="service-section-icon" aria-hidden="true">
          <i className={icon} />
        </span>
        <h4 className="service-section-title">{title}</h4>
      </header>
      <ul className="service-section-list">
        {items.map((item) => (
          <ServiceItem key={item} text={item} />
        ))}
      </ul>
      {learnMoreHref && (
        <a href={learnMoreHref} className="service-section-learn-more">
          Learn More
        </a>
      )}
    </article>
  );
}

export default function Services() {
  return (
    <div>
      <Helmet>
        <title>Our Services | Solace Integrations | Westchester, NY</title>
        <link rel="canonical" href={canonicalUrl('/services')} />
        <meta name="description" content="Network design and installation, cloud identity, storage and backup, DNS, and as-built documentation. IT infrastructure services for businesses in Westchester and Fairfield Counties." />
      </Helmet>
      <Header isFixed />
      <section className="services">
        <div className="services-hero py-5">
          <div className="container py-md-5 py-2 text-center">
            <h3 className="services-title text-center mb-lg-4 mb-3 px-lg-5">
              <span className="sub-title">What we do.</span>
              Our Services
            </h3>
            <p className="main_p4 mt-4 mb-4 pt-2 text-center mx-auto text-white">
            Solace Integrations designs and builds IT infrastructure for small and medium-sized businesses,
            specializing in networking, storage, cloud services, DNS, and systems integration. We plan,
            implement, and document the technology foundations that keep your business connected and operating efficiently.
            </p>

            <div id="all-services" className="services-grid mt-4">
              {SERVICE_SECTIONS.map((section) => (
                <ServiceSection
                  key={section.title}
                  title={section.title}
                  icon={section.icon}
                  items={section.items}
                  learnMoreHref={section.learnMoreHref}
                />
              ))}
            </div>

            <a href="/contact" className="btn solace-btn-primary btn-style mt-lg-5 mt-4">
              Contact Us Today
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
